import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../../Context/AuthContext";
import { getHostLinksReport } from "../api/shortlinksReportsApi";

export const useGetHostLinks = () => {
  const auth = useAuth();
  const { token, uid_partner } = auth.getSessionData() ?? {};

  return useQuery({
    queryKey: ["hostLinks", uid_partner],
    queryFn: async () =>
      getHostLinksReport({
        token,
        uid_partner,
      }),
    initialData: [],
    enabled:  uid_partner !== undefined,
    refetchOnWindowFocus: false,
  });
};
